// WhatsApp helper — builds wa.me deep links with pre-filled professional messages.
// Main WhatsApp: +254 706 333 829

export const BAH_WHATSAPP_NUMBER = "254706333829";
export const BAH_WHATSAPP_DISPLAY = "+254 706 333 829";
export const BAH_PHONE_DISPLAY = "+254 706 333 829";
export const BAH_EMAIL = "sales@biodealkenya.com";
export const BAH_ADDRESS_LINES = [
  "Biodeal Animal Health",
  "Biodeal Laboratories Limited",
  "Old Mombasa Road, Kyang'ombe",
  "P.O. Box 32040-00600, Nairobi, Kenya",
];

export const buildWaLink = (message) => {
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${BAH_WHATSAPP_NUMBER}?text=${text}`;
};

// Pre-defined contact-router messages from the brief.
export const WA_TEMPLATES = {
  vet:
    "Hello Biodeal Animal Health, I am a veterinary professional and I would like technical product support.",
  agrovet:
    "Hello Biodeal Animal Health, I run an agrovet and would like information on stocking your products.",
  farmer:
    "Hello Biodeal Animal Health, I need guidance on animal health products for my farm.",
  product_info:
    "Hello Biodeal Animal Health, I would like product information.",
  instruments:
    "Hello Biodeal Animal Health, I would like information on veterinary instruments.",
  cold_chain:
    "Hello Biodeal Animal Health, I would like information on vaccine carriers / cold-chain products.",
  training:
    "Hello Biodeal Animal Health, I would like to book or join a CMT / training session.",
  stockist:
    "Hello Biodeal Animal Health, I would like to apply to become a stockist.",
  distribution:
    "Hello Biodeal Animal Health, I am a distributor / institution and would like to discuss a supply partnership.",
  technical_general:
    "Hello Biodeal Animal Health technical team, I need help with the following:",
};

export const buildProductWaLink = (productName) =>
  buildWaLink(
    `Hello Biodeal Animal Health, I would like technical clarification and a product sheet for ${productName}. Please share details.`
  );

export const buildSolutionWaLink = (solutionTitle) =>
  buildWaLink(
    `Hello Biodeal Animal Health, I would like guidance on ${solutionTitle}.`
  );
